export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[650px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20vibrant%20abstract%20background%20with%20soft%20gradient%20of%20coral%20orange%20and%20golden%20amber%20tones%2C%20subtle%20curved%20shapes%20reminiscent%20of%20cinematic%20spotlights%20and%20film%20reels%2C%20clean%20minimal%20style%2C%20no%20text%20or%20logos%2C%20smooth%20texture%2C%20warm%20atmospheric%20feel%2C%20modern%20streaming%20aesthetic&width=1600&height=900&seq=douhua-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">
                美食视频聚合 · 畅快追剧
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-heading text-background-50 leading-tight mb-5">
              豆花视频
              <br className="hidden sm:block" />
              <span className="text-primary-300">免费高清追剧观影平台</span>
            </h1>

            <p className="text-base md:text-lg text-background-200/90 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              豆花视频为你聚合香蕉视频、红桃视频、蜜桃视频等美食命名视频平台，
              覆盖电视剧全集和最新电影资源，高清流畅不缓冲，随时随地畅快追剧。
              每日更新热门内容，让你第一时间看到想看的每一集。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-background-200/80 text-sm">
                <i className="ri-movie-2-line text-primary-400"></i>
                <span>覆盖7+视频平台</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80 text-sm">
                <i className="ri-flashlight-line text-primary-400"></i>
                <span>每日更新100+内容</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80 text-sm">
                <i className="ri-shield-check-line text-primary-400"></i>
                <span>免费高清无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始探索
              </a>
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-background-300/50 text-background-100 font-semibold text-base hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg"></i>
                查看最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[460px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20illustration%20of%20a%20smartphone%20floating%20above%20a%20warm%20surface%2C%20the%20phone%20screen%20shows%20colorful%20video%20content%20thumbnails%20in%20a%20grid%20layout%20with%20vibrant%20coral%20orange%20and%20amber%20highlights%2C%20surrounded%20by%20floating%20play%20button%20icons%20and%20film%20strip%20elements%2C%20clean%20composition%2C%20soft%20lighting%20from%20above%2C%20cinematic%20vibe%2C%20warm%20and%20inviting%20atmosphere&width=800&height=1000&seq=douhua-hero-visual&orientation=portrait"
                alt="豆花视频移动端追剧体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}